import { Customer } from "@/types/types";
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EventFormSectionStyles } from "./SectionStyles";

@customElement("contact-info-section")
class ContactInfoSection extends LitElement {
	static readonly styles = [EventFormSectionStyles];
	@property({ type: Object }) values: Partial<Customer> = {};

	render() {
		return html`
      <div class="form-section">
        <p class="form-section-title">📞 Kontaktinformationen</p>
        <div class="form-row">
          <basic-input 
		  	inputEventIdentifier="customer" 
			label="Ansprechpartner" 
			name="full_name" 
			style="flex: 1;"
			value="${this.values?.full_name || ''}"
			></basic-input>
          <basic-input 
			inputEventIdentifier="customer" 
			label="Email" 
			name="email" 
			style="flex: 1;"
			value="${this.values?.email || ''}"
			></basic-input>
        </div>
        <div class="form-row">
          <basic-input 
		  	inputEventIdentifier="customer" 
			label="Telefon" 
			name="phone" 
			style="flex: 1;"
			value="${this.values?.phone || ''}"
			></basic-input>
        </div>
      </div>
    `;
	}
}

export default ContactInfoSection;